<template>
  <a-card>
    <div id="components-form-demo-advanced-search">
      <router-view v-if="isRouterAlive"></router-view>
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.inboundOrder')"
              :labelCol="{span: 8}"
            >
              <a-input placeholder="..." style="width: 80%"  v-model="inboundForm.inboundOrderNo"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.shopName')"
              :labelCol="{span: 8}"
            >
              <a-select placeholder="..."
                        v-decorator="['note1', { rules: [{ required: true, message: 'Please select your shop!' }] }]"
                        v-model="inboundForm.shopId" :options="shopNames">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.warehouseList')"
              :labelCol="{span: 8}"
            >
              <a-select placeholder="..."
                        v-model="inboundForm.warehouseId" :options="warehouseOptions">
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>

        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.createTime')"
              :labelCol="{span: 8}"
            >
              <a-range-picker style="width: 80%"  :value="createTimeRangeArray" @change="onChange"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.orderStatus')"
              :labelCol="{span: 8}"
            >
              <a-select placeholder="..."  v-model="inboundForm.orderStatusId" :options="inboundOrderStatusList">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.platform')"
              :labelCol="{span: 8}"
            >
              <a-select  placeholder="..." v-model="inboundForm.platformId">
                <a-select-option value="1">AeGlobal</a-select-option>
                <a-select-option value="2">Lazada</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
        <span style="float: right; margin-top: 2px;">
          <a-button @click="handleSearch" type="primary">{{$t('message.inboundView.button.search')}}</a-button>
          <a-button @click="resetBtnClick" style="margin-left: 8px">{{$t('message.inboundView.button.reset')}}</a-button>
        </span>
        </a-row>
      </a-form>
      <br>
      <a-space class="operator">
        <a-dropdown>
          <a-menu @click="handleMenuClick" slot="overlay">
            <a-menu-item key="lazadaInboundTemplate">{{$t('message.inboundView.button.LzdTemplate')}}</a-menu-item>
            <a-menu-item key="aegInboundTemplate">{{$t('message.inboundView.button.AegTemplate')}}</a-menu-item>
          </a-menu>
          <a-button>
            {{$t('message.inboundView.button.template')}}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
        <a-button @click="handleImportBtnClick">
          {{$t('message.inboundView.button.importBtn')}}

        </a-button>
        <a-dropdown>
          <a-menu @click="handleExportClick" slot="overlay">
            <a-menu-item key="exportAllOrder">{{$t('message.inboundView.button.exportAllOrder')}}
            </a-menu-item>
            <a-menu-item key="exportSelectedOrder">{{$t('message.inboundView.button.exportSelectedOrder')}}
            </a-menu-item>
          </a-menu>
          <a-button>
            {{$t('message.inboundView.button.exportBtn')}}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
        <a-button @click="createNewInBoundOrderClick">
          {{$t('message.inboundView.button.createInboundBtn')}}
        </a-button>
      </a-space>

      <!--数据表格展示位置-->
      <a-table :columns="columns" :rowKey="rowKey" :scroll="{ x: 2500, y: 800 }" :dataSource="dataSource"
               :pagination="pagination" :loading="loading"
               @change="getTableData"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="purchaseOrderNo" slot-scope="text,record">
        <p><a slot="action" href="javascript:;" @click="showOrderDetail(record)">{{text}}</a></p>
      </span>
        <span slot="supplier" slot-scope="text,record">
        <p>{{$t('message.inboundView.table.merchantName')}}:{{ record.supplierName }}</p>
        <p>{{$t('message.inboundView.table.merchantCode')}}:{{ record.supplierId }}</p>
      </span>
        <span slot="skuRender" slot-scope="text,record">
        <p>{{$t('message.inboundView.table.skuQuantity')}}:{{ record.skusQuantity }}</p>
        <p>{{$t('message.inboundView.table.planQuantity')}}:{{ record.totalQuantity }}</p>
        <p>{{$t('message.inboundView.table.receivedQuantity')}}:{{ record.receiveSkuQuantity }}</p>
      </span>
        <template slot="action" slot-scope="text,record">
          <a slot="action" href="javascript:;" @click="showOrderDetail(record)">{{$t('message.inboundView.table.detail')}}
          </a>
          <a-divider type="vertical"/>
          <a slot="focAction" href="javascript:;" @click="jumpToFoc(record)">{{$t('message.inboundView.table.createFoc')}}
          </a>
          <template v-if="record.platformCode==1">
            <template v-if="record.orderStatusCode ==15">
              <a-divider type="vertical"/>
              <a slot="action" href="javascript:;" @click="cancelAegPurchaseOrder(record)">{{$t('message.inboundView.table.cancel')}}
              </a>
            </template>
          </template>
          <template v-if="record.platformCode==2">
            <template v-if="record.orderStatusCode <=30">
              <template v-if="record.orderStatusCode >=0">
                <a-divider type="vertical"/>
                <a slot="action" href="javascript:;" @click="cancelLzdPurchaseOrder(record)">{{$t('message.inboundView.table.cancel')}}
                </a>
              </template>
            </template>
          </template>
        </template>
      </a-table>

      <!--   导出提示框-->
      <div>
        <export-alert ref="exportAlert"></export-alert>
      </div>

      <!--导入提示框-->
      <div>
        <import-alert ref="importAlert"></import-alert>
      </div>

     <!--取消模态框-->
      <div>
        <template>
          <div>
            <a-modal v-model="visible"
                     :title="$t('message.inboundView.alert.prompt')"
                     :cancelText="$t('message.inboundView.alert.cancel')"
                     :okText="$t('message.inboundView.alert.sure')"
                     @ok="handleCancelOk">
              {{$t('message.inboundView.alert.title')}}
            </a-modal>
          </div>
        </template>
      </div>

<!--      导入模态框-->
      <div :key="importWindowKey">
        <a-modal
          :visible="importAlert.visible"
          @ok="submitImportClick"
          :closable=false
          :mask="importAlert.showMask"
          :cancelText="$t('message.inboundView.alert.cancel')"
          :kText="$t('message.inboundView.alert.sure')"
          @cancel="closeImportAlertMask"
        >
          <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-row>
              <a-col :md="24" :sm="24">
                <a-form-item
                  :label="$t('message.inboundView.alert.shop')"
                  :labelCol="{span: 5}"
                  :wrapperCol="{span: 18, offset: 1}"
                >
                  <a-select placeholder="..." v-model="importDataModel.shopId" :options="importDataModel.shopNames">
                  </a-select>
                </a-form-item>

              </a-col>
              <a-col :md="24" :sm="24">
                <a-form-item
                  :label="$t('message.inboundView.alert.selectFile')"
                  :labelCol="{span: 5}"
                  :wrapperCol="{span: 18, offset: 1}"
                >
                  <a-upload
                    name="file"
                    accept=".xlsx"
                    :maxCount=1
                    :multiple="false"
                    :showUploadList="true"
                    :action="inboundUploadAction"
                    :headers="headers"
                    :withCredentials="true"
                    :beforeUpload="beforeUpload"
                    @change="handleChange"
                  >
                    <a-button>
                      <a-icon type="upload"/>
                      {{$t('message.inboundView.button.importBtn')}}
                    </a-button>
                  </a-upload>
                </a-form-item>

              </a-col>
            </a-row>
          </a-form>
        </a-modal>
      </div>
    </div>

  </a-card>
</template>
<script>
import request from '../../utils/request'
import {InboundApi} from '../../js/InboundApi'
import {DownLoadApi} from '../../js/DownLoadApi'

export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t('message.inboundView.table.inboundOrder'),
          dataIndex: 'purchaseOrderNo',
          width: 250,
          fixed: 'left',
          scopedSlots: {customRender: 'purchaseOrderNo'},
          render: (text, row, index) => {
            console.log(text, row)
            if (text == 'null') {
              return ''
            }
          }
        },
        {
          title: this.$t('message.inboundView.table.supplier'),
          dataIndex: 'supplierName',
          width: 250,
          scopedSlots: {customRender: 'supplier'}
        },
        {
          title: this.$t('message.inboundView.table.warehouse'),
          width: 300,
          dataIndex: 'warehouse'
        },
        {
          title: this.$t('message.inboundView.table.orderQuantity'),
          dataIndex: 'skuDetails',
          width: 200,
          scopedSlots: {customRender: 'skuRender'}
        },
        {
          title: this.$t('message.inboundView.table.orderStatus'),
          width: 200,
          dataIndex: 'orderStatus'
        },
        {
          title: this.$t('message.inboundView.table.creator'),
          width: 300,
          dataIndex: 'creator'
        },
        {
          title: this.$t('message.inboundView.table.createTime'),
          width: 150,
          dataIndex: 'createTime'
        }, {
          title: this.$t('message.inboundView.table.platform'),
          width: 200,
          dataIndex: 'platform'
        },
        {
          title: this.$t('message.inboundView.table.expectedTime'),
          width: 150,
          dataIndex: 'preArrivalTime'
        },
        {
          title: this.$t('message.inboundView.table.expiredTime'),
          width: 150,
          dataIndex: 'expireTime'
        }, {
          title: this.$t('message.inboundView.table.operate'),
          width: 200,
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ]
    }
  },
  data () {
    return {
      shopNames: [],
      tempData: {
        cancelInboundOrderCode: '',
        cancelInboundUserId: ''
      },
      visible: false,
      importWindowKey: '',
      importDataModel: {
        shopId: '',
        shopNames: []
      },
      importAlert: {
        visible: false,
        showMask: true
      },
      isRouterAlive: false,
      fileList: [],
      uploading: false,
      createTimeRangeArray: [],
      warehouseOptions: [],
      inboundOrderStatusList: [],
      pagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          console.log('change current=', this.pagination.current)
          this.getTableData()
        }
      },
      rowKey: 'id',
      loading: true,
      dataSource: this.dataSource,
      selectedRowKeys: [], // Check here to configure the default column
      expiredOrderDialog: {
        visible: false,
        confirmLoading: false
      },
      uploadParameter: {
        domain: 'purchase',
        _scm_token_: 'v6ISYRoOnMF2arTlLBzbTX8WwH4'
      },
      exportOrderHeaders: {
        authorization: 'authorization-text'
      },
      newOrderDialog: {
        visible: false,
        confirmLoading: false
      },
      inboundForm: InboundApi.inboundFromRequest,
      expand: false,
      exportRequestJson: '',
      exportTypeVal: 0,
      showExportAlert: false,
      inboundUploadAction: InboundApi.InboundFromUrl.inboundOrderImportUrl,
      form: this.$form.createForm(this, {name: 'advanced_search'})
    }
  },
  created () {
    /** 清空页面查询数据**/
    this.clearFromClick()
    this.getTableData()
    // 初始化界面数据
    this.initInboundData()
    this.selectedRowKeys = []
  },
  methods: {
    createNewInBoundOrderClick (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(this.inboundForm)
          this.$router.push({name: 'createNewInboundOrder', query: {inboundDetailData: this.inboundForm}})
        }
      })
    },
    handleCancelOk () {
      let cancelParam = {
        orderNumber: this.tempData.cancelInboundOrderCode,
        userId: this.tempData.cancelInboundUserId
      }
      console.log(InboundApi.InboundFromUrl.inboundOrderCancelUrl)
      console.log(InboundApi.InboundFromUrl.inboundOrderCancelUrl)
      request({
        method: 'post',
        url: InboundApi.InboundFromUrl.inboundOrderCancelUrl,
        data: cancelParam
      }).then(response => {
        console.log(response)
        if (response.data.success) {
          this.visible = false
          this.getTableData()
        } else {
          this.$message.error(response.data.errorMessage)
        }
      })
    },
    submitImportClick () {
      const formData = new FormData()
      if (this.importDataModel.shopId == '') {
        this.$message.error('请选择店铺信息')
        return
      }
      if (this.fileList == null || this.fileList.length == 0) {
        this.$message.error('请选择需要上传的文件')
        return
      }
      this.fileList.forEach(file => {
        formData.append('file', file)
      })

      this.$refs.importAlert.showImportAlertMask()
      request({
        headers: {
          importSellerId: this.importDataModel.shopId,
          taskType: 1003
        },
        url: this.inboundUploadAction,
        method: 'post',
        processData: false,
        data: formData
      }).then(response => {
        console.log(response)
        if (response.data.success) {
          this.importAlert.visible = false
          var taskId = response.data.model
          this.$refs.importAlert.showImportWindow(taskId)
        } else {
          this.$message.error('file upload failed.`)')
        }
      })
    },
    closeImportAlertMask () {
      this.importAlert.visible = false
      this.importWindowKey = Math.random()
    },
    cancelAegPurchaseOrder (record) {
      this.visible = true
    },
    cancelLzdPurchaseOrder (record) {
      this.tempData.cancelInboundOrderCode = record.purchaseOrderNo
      this.tempData.cancelInboundUserId = record.userId
      this.visible = true
    },
    handleImportBtnClick () {
      this.importDataModel.shopId = ''
      this.importWindowKey = Math.random()
      this.fileList = []
      request({
        url: InboundApi.InboundFromUrl.queryShopNames,
        method: 'get'
      }).then(response => {
        this.importDataModel.shopNames = response.data.model.map(item => {
          return {label: item.name, value: item.sellerId}
        })
      })
      this.importAlert.visible = true
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.getTableData()
      })
    },
    onChange (date, dateString) {
      this.createTimeRangeArray = date
      // 为变量赋值
      this.inboundForm.cFromTime = dateString[0]
      this.inboundForm.cToTime = dateString[1]
      console.log(this.inboundForm)
    },
    handleSearch (e) {
      this.selectedRowKeys = []
      this.pagination.defaultPageSize = 10
      this.pagination.pageSize = 10
      this.pagination.current = 1
      this.getTableData(this.inboundForm)
    },
    addShowModal () {
      this.newOrderDialog.visible = true
      this.fileList = []
    },
    addExpiredTime () {
      this.expiredOrderDialog.visible = true
    },
    handleMenuClick (e) {
      if (e.key == 'lazadaInboundTemplate') {
        let param = new URLSearchParams()
        param.append('filename', 'inboundOrderTemplate.xlsx')
        DownLoadApi.DownLoadTemplateFile(InboundApi.InboundFromUrl.downloadExcelTemplateUrl, param)
      } else if (e.key == 'aegInboundTemplate') {

      }
    },
    handleExportClick (e) {
      if (e.key == 'exportAllOrder') {
        this.inboundForm.ids = ''
        this.$refs.exportAlert.exportFile(this.inboundForm, 1001)
      } else if (e.key == 'exportSelectedOrder') {
        this.$refs.exportAlert.exportFile(this.inboundForm, 1001)
      }
    },
    addNewOrderHandleOk (e) {
      this.newOrderDialog.confirmLoading = true
      setTimeout(() => {
        this.newOrderDialog.visible = false
        this.newOrderDialog.confirmLoading = false
      }, 2000)
      this.$message.success('upload successfully.')
    },
    addNewOrderHandleCancel (e) {
      this.newOrderDialog.visible = false
    },
    exportOrderHandleChange (info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        console.info(info.fileList[0].response)
        // 获取到响应后，可以为全局变量赋值
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    expiredNewOrderHandleOk () {

    },
    expiredNewOrderHandleCancel () {
      this.expiredOrderDialog.visible = false
    },
    expiredTimeOnChange (date, dateString) {

    },
    showOrderDetail (record) {
      console.log(record)
      if (record.platform == 'AEG') {
        this.$router.push({name: 'inboundDetail', query: {purchaseLineData: record}})
      } else {
        this.$router.push({name: 'lzdinboundDetail', query: {purchaseLineData: record}})
      }
    },
    jumpToFoc (record) {
      request({
        url: '/foc/getSSOToken?shipperId=3944706226&loginId=testcbshop1803@gmail.com',
        method: 'get'
      }).then(response => {
        console.log(response)
        window.location.href = 'https://cnlogin.cainiao.com/doSsoLogin?st=' + response.data.model + '&redirectURL=https://g.cainiao.com/perform/foc/foc/edit?orderCode=' + record.purchaseOrderNo
      })
    },
    resetBtnClick () {
      const inboundFormVar = {
        inboundOrderNo: '',
        shopId: '',
        lbxOrderCode: '',
        warehouseId: '',
        orderStatusId: '',
        platformId: '',
        cFromTime: '',
        cToTime: '',
        ids: ''
      }
      this.inboundForm = inboundFormVar
      this.createTimeRangeArray = []
      this.getTableData()
    },
    clearFromClick () {
      const inboundFormVar = {
        inboundOrderNo: '',
        shopId: '',
        lbxOrderCode: '',
        warehouseId: '',
        orderStatusId: '',
        platformId: '',
        cFromTime: '',
        cToTime: '',
        ids: ''
      }
      this.inboundForm = inboundFormVar
      this.createTimeRangeArray = []
    },
    // 表格选择事件
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      if (selectedRowKeys !== undefined && selectedRowKeys.length > 0) {
        this.inboundForm.ids = selectedRowKeys.join(',')
      }
    },

    initInboundData () {
      request({
        url: InboundApi.InboundFromUrl.queryShopNames,
        method: 'get'
      }).then(response => {
        this.shopNames = response.data.model.map(item => {
          return {label: item.name, value: item.sellerId}
        })
      })
      request({
        url: InboundApi.InboundFromUrl.queryWarehouseUrl,
        method: 'get'
      }).then(response => {
        this.warehouseOptions = response.data.model.map(item => {
          return {label: item.name, value: item.storeCode}
        })
      })
      request({
        url: InboundApi.InboundFromUrl.queryOrderStatusUrl,
        method: 'get'
      }).then(response => {
        console.log(response)
        this.inboundOrderStatusList = response.data.model.map(item => {
          return {label: item.name, value: item.value}
        })
      })
    },
    getTableData (code) {
      this.inboundForm.ids = ''
      this.inboundForm.pageSize = this.pagination.pageSize
      this.inboundForm.pageIndex = this.pagination.current
      this.loading = true
      this.inboundForm.startTime = this.inboundForm.cFromTime
      this.inboundForm.endTime = this.inboundForm.cToTime
      console.log(this.inboundForm)
      let inboundOrderQueryVo = this.inboundForm
      request({
        url: InboundApi.InboundFromUrl.queryInboundOrderUrl,
        method: 'post',
        data: inboundOrderQueryVo
      }).then(response => {
        // response.data = json
        console.log(response)
        this.dataSource = response.data.model
        const pagination = {...this.pagination}
        pagination.total = response.data.totalCount
        this.pagination = pagination
        this.loading = false
      })
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload (file) {
      this.fileList = []
      this.fileList = [...this.fileList, file]
      console.log(this.fileList)
      return false
    },
    handleChange (info) {
      if (info.file.status === 'done') {
        var taskId = info.fileList[0].response.model
        this.$refs.importAlert.showImportWindow(taskId)
      } else if (info.file.status === 'error') {
        console.log(info)
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    }

  }
}
</script>

<style>

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .notshow {
    display: none;
  }

  .editable-row-operations a {
    margin-right: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/views/icp/Inbound.vue